import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import zh from "./locales/zh.json"

const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'zh', // 回退语言
  locale: "zh",
  messages: {
    zh,
    en
  }
})

export default i18n
